import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";

let props = {};
let inputObj = {};
let InputJSONString = "";
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

export const loadFeeCodes = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "F4_FEE_CODE_CHARGE_BASIS";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const loadUnitType = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "F4_UNIT_TYPES";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const loadCurrencyDropdown = async () => {
  // InputJSONString = JSON.stringify(input);
  inputObj["Activity"] = "F4_SCAC_CURR";
  inputObj["Input"] = JSON.stringify("");
  props.input = inputObj;

  const responseArray = await GatewayGet(props, props.input);
  const currency = [];
  for (var i = 0; i < responseArray.length; i++) {
    var currencyObj = {};
    currencyObj["currency"] = responseArray[i].currCode;
    currency.push(currencyObj);
  }
  return currency;
};

export const saveQuotation = async (data) => {
  inputObj["Activity"] = "INVOICE_QUOTE_DB_OPS";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const getQuotation = async (data) => {

  inputObj["Activity"] = "INVOICE_QUOTE_SEARCH";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const deleteQuotation = async (data) => {
  inputObj["Activity"] = "INVOICE_QUOTE_DB_OPS";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};